import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/authContext";
import styles from './auth.module.css'

import Input from "../../components/Form/Input";
import Button from "../../components/Form/Button";
import HeaderAuth from "./HeaderAuth";
import FormGroup from './../../components/Form/FormGroup';

const Login = () => {
    const [user, setUser] = useState({})

    const { login } = useAuth()

    const handleSubmit = async (e) => {
        e.preventDefault()
        await login(user)
    }

    return (
        <>
            <HeaderAuth />
            <div className={styles.container}>
                <div className={styles.content}>
                    <div className={styles.groupForm}>
                        <h1>Entre em sua conta</h1>
                        <form onSubmit={handleSubmit}>
                            <FormGroup labelText="E-mail">
                                <Input
                                    type="email"
                                    placeholder="E-mail"
                                    value={user?.email || ""}
                                    onChange={(e) => setUser({ ...user, email: e.target.value })}
                                />
                            </FormGroup>
                            <FormGroup labelText="Senha">
                                <Input
                                    type="password"
                                    placeholder="Senha"
                                    value={user?.password || ""}
                                    onChange={(e) => setUser({ ...user, password: e.target.value })}
                                />
                            </FormGroup>
                            <Button variant="primary" disabled={!user?.email || !user?.password}>Entrar</Button>
                        </form>
                    </div>
                    <div className={styles.actions}>
                        <Link to="/reset-password">Esqueceu sua senha?</Link>
                        <a href="https://oktto.com.br/politica-de-privacidade/" target="_blank" rel="noopener noreferrer">Política de Privacidade</a>
                        <a href="https://oktto.com.br/termos-de-servico/" target="_blank" rel="noopener noreferrer">Termos de Serviço</a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Login
